// เนื้อเรื่องเฉพาะกลุ่มย่อยของนก

import type { GameEvent } from "../../engine/types";

const B = ["BIRD"] as const;

export const BIRD_SUBGROUP_EVENTS: readonly GameEvent[] = [
  // ---------- นกล่าเหยื่อ ----------
  {
    id: "raptor_sibling",
    archetypes: B,
    stages: ["nestling"],
    requires: { subgroups: ["bird.raptor"] },
    weight: 7,
    text: "รังของคุณอยู่บนยอดไม้สูง พี่ที่ฟักก่อนตัวใหญ่กว่าคุณเกือบเท่าตัว",
    fact: "ในรังของนกล่าเหยื่อหลายชนิด ลูกที่ฟักก่อนมักตัวโตกว่าและแย่งอาหารจากน้องได้มากกว่า",
    choices: [
      {
        label: "แย่งอาหารสู้พี่",
        outcomes: [
          { chance: 0.5, text: "คุณได้เนื้อชิ้นใหญ่!", effects: { fullness: 35 } },
          { chance: 0.5, text: "พี่จิกคุณจนต้องถอย", effects: { fullness: 5, health: -10, cause: "accident" } },
        ],
      },
      { label: "รอตอนพี่อิ่มแล้ว", outcomes: [{ chance: 1, text: "พ่อแม่ป้อนคุณหลังพี่กินอิ่ม", effects: { fullness: 20 } }] },
    ],
  },
  {
    id: "raptor_thermal",
    archetypes: B,
    stages: ["adult", "elder"],
    requires: { subgroups: ["bird.raptor"] },
    weight: 5,
    text: "อากาศร้อนลอยขึ้นจากพื้นเป็นกระแสลมหมุนวน",
    fact: "นกล่าเหยื่อขนาดใหญ่ใช้กระแสลมร้อนที่ลอยขึ้นจากพื้นช่วยยกตัว จึงร่อนได้นานโดยแทบไม่ต้องกระพือปีก",
    choices: [
      { label: "กางปีกร่อนตามลมร้อน", outcomes: [{ chance: 1, text: "คุณลอยสูงขึ้นไปโดยแทบไม่ต้องออกแรง มองเห็นเหยื่อได้ทั่วทุ่ง", effects: { safety: 10, fullness: 5 } }] },
      { label: "เกาะกิ่งไม้รอเหยื่อ", outcomes: [{ chance: 1, text: "คุณประหยัดแรง แต่มองเห็นได้ไม่ไกลนัก", effects: { health: 5 } }] },
    ],
  },
  {
    id: "raptor_strike",
    archetypes: B,
    stages: ["fledgling", "adult", "elder"],
    requires: { subgroups: ["bird.raptor"] },
    weight: 8,
    text: "สายตาคมกริบของคุณมองเห็นหนูตัวหนึ่งวิ่งอยู่ในทุ่งไกลลิบ",
    choices: [
      {
        label: "หุบปีกพุ่งลงไป",
        outcomes: [
          { chance: 0.6, text: "กรงเล็บของคุณจับเหยื่อได้ในพริบตา", effects: { fullness: 40 } },
          { chance: 0.4, text: "เหยื่อมุดลงรูทัน", effects: { fullness: -5 } },
        ],
      },
      {
        label: "บินวนรอจังหวะ",
        outcomes: [
          { chance: 0.5, text: "รอจนมันออกมาที่โล่ง แล้วจับได้", effects: { fullness: 35 } },
          { chance: 0.5, text: "อีกาบินมาก่อกวนจนเหยื่อหนีไป", effects: { fullness: -5 } },
        ],
      },
    ],
  },
  {
    id: "raptor_poison",
    archetypes: B,
    stages: ["adult", "elder"],
    requires: { subgroups: ["bird.raptor"] },
    weight: 1.5,
    threatenedWeight: 2.5,
    text: "คุณเจอซากสัตว์ถูกทิ้งไว้กลางทุ่ง ไม่มีสัตว์อื่นแตะต้องเลย",
    fact: "นกล่าเหยื่อและแร้งจำนวนมากตายเพราะกินซากสัตว์ที่ถูกวางยาเบื่อ",
    choices: [
      {
        label: "ลงไปกินซาก",
        outcomes: [
          { chance: 0.5, text: "อาหารมื้อใหญ่ ไม่มีอะไรผิดปกติ", effects: { fullness: 35 } },
          { chance: 0.4, text: "ซากถูกวางยาไว้ คุณป่วยหนักหลายวัน", effects: { health: -40, cause: "human" } },
          { chance: 0.1, text: "ยาเบื่อออกฤทธิ์แรงเกินไป", effects: { death: "human" } },
        ],
      },
      { label: "ไม่ไว้ใจ บินผ่านไป", outcomes: [{ chance: 1, text: "คุณบินไปล่าเหยื่อสดแทน", effects: { fullness: 10 } }] },
    ],
  },

  // ---------- นกแก้ว ----------
  {
    id: "parrot_cavity",
    archetypes: B,
    stages: ["nestling"],
    requires: { subgroups: ["bird.parrot"] },
    weight: 6,
    text: "คุณอยู่ในโพรงไม้มืดๆ พ่อแม่ขย้อนอาหารที่ย่อยแล้วมาป้อน",
    choices: [
      { label: "อ้าปากกว้างๆ", outcomes: [{ chance: 1, text: "อาหารอุ่นๆ ทำให้ท้องอิ่ม", effects: { fullness: 35 } }] },
      { label: "ร้องเสียงดังเรียกพ่อแม่", outcomes: [{ chance: 1, text: "พ่อแม่รีบบินกลับมา แต่เสียงก็ดังออกไปนอกโพรง", effects: { fullness: 30, safety: -10 } }] },
    ],
  },
  {
    id: "parrot_clay_lick",
    archetypes: B,
    stages: ["fledgling", "adult", "elder"],
    requires: { subgroups: ["bird.parrot"] },
    weight: 5,
    text: "ฝูงนกแก้วมารวมตัวกันที่หน้าผาดินริมแม่น้ำ",
    fact: "นกแก้วมาคอว์ในอเมซอนกินดินจากหน้าผาริมแม่น้ำ เชื่อกันว่าช่วยเสริมแร่ธาตุที่ขาด",
    choices: [
      { label: "ลงไปกินดินกับฝูง", outcomes: [{ chance: 1, text: "แร่ธาตุในดินช่วยให้ร่างกายแข็งแรง", effects: { health: 15 } }] },
      { label: "เฝ้าระวังภัยให้ฝูง", outcomes: [{ chance: 1, text: "คุณส่งเสียงเตือนตอนเหยี่ยวบินมา ทั้งฝูงรอด", effects: { safety: 15 } }] },
    ],
  },
  {
    id: "parrot_mimic",
    archetypes: B,
    stages: ["adult"],
    requires: { subgroups: ["bird.parrot"], notFlags: ["has_mate"] },
    weight: 5,
    text: "คุณได้ยินเสียงร้องของนกแก้วตัวหนึ่งที่ฟังแล้วถูกใจ",
    choices: [
      { label: "ร้องเลียนเสียงตอบ", outcomes: [{ chance: 1, text: "เสียงของคุณเหมือนจนอีกตัวบินมาเกาะข้างๆ", effects: { addFlags: ["has_mate"] } }] },
      { label: "แกล้งทำไม่สนใจ", outcomes: [{ chance: 1, text: "มันบินจากไปหาตัวอื่น" }] },
    ],
  },
  {
    id: "parrot_poacher",
    archetypes: B,
    stages: ["nestling", "fledgling", "adult"],
    requires: { subgroups: ["bird.parrot"] },
    weight: 1.5,
    threatenedWeight: 3,
    text: "มีคนปีนต้นไม้ขึ้นมาใกล้โพรงรัง ในมือถือถุงผ้า",
    fact: "การจับนกแก้วจากธรรมชาติไปขายเป็นสัตว์เลี้ยง เป็นสาเหตุสำคัญที่ทำให้นกแก้วหลายชนิดใกล้สูญพันธุ์",
    choices: [
      {
        label: "ซุกตัวลึกเข้าไปในโพรง",
        outcomes: [
          { chance: 0.6, text: "โพรงลึกเกินกว่ามือเขาจะเอื้อมถึง", effects: { safety: -10 } },
          { chance: 0.4, text: "คุณถูกจับใส่ถุง และถูกพาไปขาย ชีวิตในป่าของคุณจบลง", effects: { death: "human" } },
        ],
      },
      {
        label: "ร้องเสียงดังเรียกฝูง",
        outcomes: [
          { chance: 0.7, text: "ฝูงนกบินโฉบวนจนเขาตกใจปีนลงไป", effects: { safety: 5 } },
          { chance: 0.3, text: "เสียงร้องทำให้เขาหาตัวคุณเจอเร็วขึ้น", effects: { death: "human" } },
        ],
      },
    ],
  },

  // ---------- นกเงือกและนกหัวขวาน ----------
  {
    id: "hornbill_cavity_life",
    archetypes: B,
    stages: ["egg", "nestling"],
    requires: { subgroups: ["bird.hornbill_woodpecker"], families: ["Bucerotidae"] },
    weight: 6,
    text: "คุณอยู่ในโพรงลึกของต้นไม้ใหญ่ มีช่องเล็กๆ ให้แสงส่องเข้ามา",
    fact: "นกเงือกตัวเมียขังตัวเองไว้ในโพรงรังโดยใช้ดินและเศษอาหารปิดปากโพรง เหลือช่องแคบๆ ให้ตัวผู้ส่งอาหารเข้ามา",
    choices: [{ label: "รออาหารที่ส่งเข้ามาทางช่องเล็กๆ", outcomes: [{ chance: 1, text: "ผลไม้สุกถูกส่งเข้ามาทีละลูก คุณปลอดภัยในโพรง", effects: { fullness: 25, safety: 10 } }] }],
  },
  {
    id: "woodpecker_cavity",
    archetypes: B,
    stages: ["nestling"],
    requires: { subgroups: ["bird.hornbill_woodpecker"], notFamilies: ["Bucerotidae"] },
    weight: 6,
    text: "คุณอยู่ในโพรงที่พ่อแม่เจาะไว้ในลำต้นไม้ ได้ยินเสียงพ่อแม่เกาะเปลือกไม้อยู่ข้างนอก",
    fact: "นกหัวขวานมีกะโหลกและกล้ามเนื้อที่ช่วยลดแรงกระแทก จึงเจาะต้นไม้ได้วันละหลายพันครั้ง",
    choices: [
      { label: "ร้องเรียกอาหาร", outcomes: [{ chance: 1, text: "พ่อแม่ยื่นหนอนตัวอ้วนเข้ามาในโพรง", effects: { fullness: 30 } }] },
      { label: "เงียบไว้ให้ปลอดภัย", outcomes: [{ chance: 1, text: "งูที่เลื้อยผ่านไม่รู้ว่ามีลูกนกอยู่ในโพรง", effects: { safety: 10, fullness: 10 } }] },
    ],
  },
  {
    id: "hornbill_fig",
    archetypes: B,
    stages: ["fledgling", "adult", "elder"],
    requires: { subgroups: ["bird.hornbill_woodpecker"] },
    weight: 7,
    text: "ต้นไทรใหญ่ออกผลสุกเต็มต้น นกหลายชนิดมารวมกันที่นี่",
    fact: "ต้นไทรเป็นแหล่งอาหารสำคัญของนกเงือก และนกเงือกก็ช่วยกระจายเมล็ดไปปลูกป่าได้ไกลหลายกิโลเมตร",
    choices: [
      { label: "กินผลไทรให้อิ่ม", outcomes: [{ chance: 1, text: "คุณอิ่มแล้ว และพาเมล็ดไปถ่ายไว้ไกลออกไปกลางป่า", effects: { fullness: 40 } }] },
      {
        label: "เจาะหาแมลงในเปลือกไม้แถวนั้น",
        outcomes: [{ chance: 1, text: "หนอนตัวอ้วนซ่อนอยู่ใต้เปลือกไม้", effects: { fullness: 25, safety: 5 } }],
      },
    ],
  },
  {
    id: "hornbill_tree_cut",
    archetypes: B,
    stages: ["adult", "elder"],
    requires: { subgroups: ["bird.hornbill_woodpecker"] },
    weight: 1.5,
    threatenedWeight: 2.5,
    text: "ต้นไม้ใหญ่ที่คุณใช้ทำรังทุกปี ถูกตัดล้มลงแล้ว",
    fact: "นกเงือกต้องใช้โพรงในต้นไม้ใหญ่อายุหลายสิบปีเป็นรัง การตัดไม้ใหญ่จึงทำให้นกเงือกไม่มีที่ทำรัง",
    choices: [
      {
        label: "บินหาโพรงใหม่ในป่าลึก",
        outcomes: [
          { chance: 0.5, text: "คุณเจอโพรงใหม่ หลังบินหาอยู่หลายวัน", effects: { fullness: -20 } },
          { chance: 0.5, text: "หาไม่เจอ ปีนี้คุณไม่มีที่ทำรัง", effects: { fullness: -15, removeFlags: ["has_mate"] } },
        ],
      },
      { label: "แย่งโพรงจากนกตัวอื่น", outcomes: [{ chance: 1, text: "คุณได้โพรงมา แต่ก็บาดเจ็บจากการต่อสู้", effects: { health: -20, cause: "accident" } }] },
    ],
  },

  // ---------- นกน้ำและนกทะเล ----------
  {
    id: "water_swim_first",
    opening: true,
    archetypes: B,
    stages: ["nestling"],
    requires: { subgroups: ["bird.waterbird"] },
    once: true,
    weight: 15,
    text: "พ่อแม่ลงน้ำแล้วส่งเสียงเรียก ถึงเวลาว่ายน้ำครั้งแรก",
    choices: [
      {
        label: "กระโดดลงน้ำตามไป",
        outcomes: [
          { chance: 0.8, text: "คุณลอยตัวได้ทันที ขนอ่อนกันน้ำได้ดี", effects: { safety: 10, fullness: 10 } },
          { chance: 0.2, text: "คุณสำลักน้ำนิดหน่อย แต่ก็ว่ายตามทัน", effects: { health: -5 } },
        ],
      },
      { label: "รอจนพี่น้องลงก่อน", outcomes: [{ chance: 1, text: "คุณว่ายรั้งท้ายแถว", effects: { safety: -5 } }] },
    ],
  },
  {
    id: "water_fishing",
    archetypes: B,
    stages: ["fledgling", "adult", "elder"],
    requires: { subgroups: ["bird.waterbird"] },
    weight: 8,
    text: "ปลาฝูงเล็กว่ายอยู่ใต้ผิวน้ำใสๆ",
    choices: [
      {
        label: "ยืนนิ่งรอให้ปลาว่ายเข้ามา",
        outcomes: [
          { chance: 0.7, text: "จังหวะเดียว คุณจิกปลาขึ้นมาได้", effects: { fullness: 35 } },
          { chance: 0.3, text: "รอนานจนขาชา ปลาไม่มาสักที", effects: { fullness: -5 } },
        ],
      },
      {
        label: "ดำน้ำลงไปไล่จับ",
        outcomes: [
          { chance: 0.6, text: "คุณได้ปลาตัวใหญ่", effects: { fullness: 40 } },
          { chance: 0.4, text: "ปลากระจายหนี เสียแรงเปล่า", effects: { fullness: -10 } },
        ],
      },
    ],
  },
  {
    id: "water_mudflat",
    archetypes: B,
    stages: ["adult", "elder"],
    requires: { subgroups: ["bird.waterbird"], canFly: true },
    weight: 4,
    text: "ระหว่างอพยพ คุณบินผ่านหาดเลนกว้างที่เต็มไปด้วยปูและหนอน",
    fact: "นกชายเลนอพยพหลายชนิดต้องแวะหาดเลนตามเส้นทางเพื่อเติมพลัง อ่าวไทยตอนในเป็นจุดแวะพักสำคัญจุดหนึ่ง",
    choices: [
      { label: "แวะพักเติมพลังหลายวัน", outcomes: [{ chance: 1, text: "คุณกินจนน้ำหนักขึ้น พร้อมบินต่ออีกไกล", effects: { fullness: 40, health: 10 } }] },
      {
        label: "บินต่อไม่หยุด",
        outcomes: [
          { chance: 0.6, text: "คุณถึงที่หมายเร็วกว่าตัวอื่น", effects: { fullness: -15 } },
          { chance: 0.4, text: "คุณหมดแรงกลางทาง", effects: { fullness: -25, health: -15, cause: "disaster" } },
        ],
      },
    ],
  },
  {
    id: "water_oil",
    archetypes: B,
    stages: ["adult", "elder"],
    requires: { subgroups: ["bird.waterbird"], habitat: ["sea"] },
    weight: 1.5,
    threatenedWeight: 2,
    text: "ผิวน้ำข้างหน้ามีคราบสีดำมันวาวลอยเป็นแพ",
    choices: [
      { label: "บินอ้อมไปหากินที่อื่น", outcomes: [{ chance: 1, text: "คุณเสียเวลาไปมาก แต่ขนยังสะอาด", effects: { fullness: -10 } }] },
      {
        label: "ลงไปจับปลาตรงนั้น",
        outcomes: [
          { chance: 0.3, text: "คุณได้ปลาและบินขึ้นมาได้", effects: { fullness: 20 } },
          { chance: 0.6, text: "คราบน้ำมันเกาะขนจนกันน้ำไม่ได้ ร่างกายเย็นเฉียบ", effects: { health: -35, cause: "human" } },
          { chance: 0.1, text: "ปีกหนักจนบินไม่ขึ้น", effects: { death: "human" } },
        ],
      },
    ],
  },

  // ---------- นกเกาะคอน ----------
  {
    id: "passerine_cuckoo",
    archetypes: B,
    stages: ["nestling"],
    requires: { subgroups: ["bird.passerine"] },
    once: true,
    weight: 4,
    text: "ในรังมีลูกนกตัวหนึ่งที่ตัวใหญ่ผิดปกติ และหน้าตาไม่เหมือนพี่น้องเลย",
    fact: "นกคัดคูบางชนิดแอบวางไข่ในรังนกอื่น และลูกนกคัดคูมักเบียดไข่หรือลูกนกเจ้าของรังออกจากรัง",
    choices: [
      {
        label: "เกาะขอบรังไว้แน่น",
        outcomes: [
          { chance: 0.6, text: "คุณไม่ยอมโดนเบียดตกรัง", effects: { fullness: -10, safety: -5 } },
          { chance: 0.4, text: "มันเบียดคุณตกลงจากรัง", effects: { death: "accident" } },
        ],
      },
      { label: "ร้องให้ดังกว่ามัน", outcomes: [{ chance: 1, text: "พ่อแม่ยังป้อนคุณบ้าง แม้มันจะแย่งไปเกือบหมด", effects: { fullness: 10 } }] },
    ],
  },
  {
    id: "passerine_song",
    archetypes: B,
    stages: ["fledgling", "adult"],
    requires: { subgroups: ["bird.passerine"] },
    weight: 5,
    text: "พ่อร้องเพลงอยู่บนกิ่งไม้ทุกเช้า",
    fact: "นกเกาะคอนหลายชนิดเรียนรู้เพลงจากการฟังนกตัวโตเต็มวัย คล้ายกับที่เด็กหัดพูด",
    choices: [
      { label: "ฝึกร้องตามทุกวัน", outcomes: [{ chance: 1, text: "เสียงเพลงของคุณไพเราะขึ้นเรื่อยๆ", effects: { addFlags: ["good_song"], fullness: -5 } }] },
      { label: "ใช้เวลาหาแมลงกินดีกว่า", outcomes: [{ chance: 1, text: "อิ่มดี แต่เพลงของคุณยังเพี้ยนอยู่", effects: { fullness: 20 } }] },
    ],
  },
  {
    id: "passerine_song_payoff",
    archetypes: B,
    stages: ["adult"],
    requires: { subgroups: ["bird.passerine"], flags: ["good_song"], notFlags: ["has_mate"] },
    weight: 10,
    text: "เช้านี้คุณเกาะยอดไม้สูงสุด พร้อมร้องเพลงประจำฤดู",
    choices: [{ label: "ร้องเพลงที่ฝึกมา", outcomes: [{ chance: 1, text: "เพลงของคุณดังก้องไปทั่ว และมีนกตัวหนึ่งบินมาหา", effects: { addFlags: ["has_mate"], safety: -5 } }] }],
  },
  {
    id: "passerine_cat",
    archetypes: B,
    stages: ["fledgling", "adult", "elder"],
    requires: { subgroups: ["bird.passerine", "bird.other"], habitat: ["urban", "grassland"] },
    weight: 3,
    text: "แมวบ้านตัวหนึ่งหมอบต่ำอยู่หลังพุ่มไม้ หางกระดิกช้าๆ",
    fact: "แมวบ้านที่ปล่อยให้ออกไปนอกบ้าน เป็นนักล่าที่ฆ่านกเล็กไปจำนวนมากในหลายประเทศ",
    choices: [
      { label: "บินขึ้นที่สูงทันที", outcomes: [{ chance: 1, text: "แมวกระโดดตะครุบได้แค่อากาศ", effects: { safety: 10, fullness: -5 } }] },
      {
        label: "จิกเมล็ดพืชต่ออีกนิด",
        outcomes: [
          { chance: 0.5, text: "คุณได้กินอีกหน่อยก่อนบินหนี", effects: { fullness: 15 } },
          { chance: 0.35, text: "อุ้งเท้าแมวเฉี่ยวหางคุณ ขนหลุดไปหลายเส้น", effects: { health: -20, cause: "predator" } },
          { chance: 0.15, text: "แมวเร็วกว่าที่คิด", effects: { death: "predator" } },
        ],
      },
    ],
  },

  // ---------- นกอื่นๆ (นกพิราบ ไก่ฟ้า นกกระเต็น นกแอ่น ฯลฯ) ----------
  {
    id: "birdother_dust_bath",
    archetypes: B,
    stages: ["fledgling", "adult", "elder"],
    requires: { subgroups: ["bird.other"] },
    weight: 5,
    text: "ตัวคันยุบยิบ มีเหาอยู่ในขน",
    choices: [
      { label: "อาบฝุ่นในดินแห้ง", outcomes: [{ chance: 1, text: "ฝุ่นช่วยไล่เหาจนตัวสะอาด", effects: { health: 15 } }] },
      { label: "ไซ้ขนด้วยปากทีละเส้น", outcomes: [{ chance: 1, text: "ช้าหน่อยแต่ได้ผล", effects: { health: 8, fullness: -5 } }] },
    ],
  },
  {
    id: "birdother_display",
    archetypes: B,
    stages: ["adult"],
    requires: { subgroups: ["bird.other"], notFlags: ["has_mate"] },
    weight: 7,
    text: "ฤดูเกี้ยวพาราสีมาถึง ตัวอื่นเริ่มรำแพนขนกันแล้ว",
    choices: [
      {
        label: "โชว์ขนและเต้นรำเต็มที่",
        outcomes: [
          { chance: 0.65, text: "การแสดงของคุณสะกดสายตา คุณได้คู่!", effects: { addFlags: ["has_mate"], fullness: -10 } },
          { chance: 0.35, text: "เต้นจนเหนื่อย แต่ไม่มีใครสนใจ", effects: { fullness: -15 } },
        ],
      },
      { label: "ร้องเรียกเบาๆ อยู่ข้างทาง", outcomes: [{ chance: 1, text: "มีตัวหนึ่งเดินเข้ามาหาอย่างเขินๆ", effects: { addFlags: ["has_mate"] } }] },
    ],
  },
  {
    id: "birdother_ground_food",
    archetypes: B,
    stages: ["fledgling", "adult", "elder"],
    requires: { subgroups: ["bird.other"] },
    weight: 7,
    text: "คุณเดินคุ้ยเขี่ยพื้นป่า เจอเมล็ดพืชกับแมลงเต็มไปหมด",
    choices: [
      { label: "คุ้ยหาต่อไปเรื่อยๆ", outcomes: [{ chance: 1, text: "อิ่มแปล้", effects: { fullness: 35, safety: -5 } }] },
      { label: "กินแล้วบินขึ้นคอนพัก", outcomes: [{ chance: 1, text: "ปลอดภัยไว้ก่อน", effects: { fullness: 20, safety: 5 } }] },
    ],
  },
];
